<template>
  <div
    v-if="item.resource"
    data-qa="resource-name">
    <span class="h7-text-medium">#{{ item.index || item.id }}. {{ item.resource.name }} </span>
    <v-subheader class="pl-0 h8-text secondary__green_not_active--text">
      {{ item.resource.category ? item.resource.category.code : '' }}
      {{ item.resource.category ? item.resource.category.name :
        item.resource.group ? item.resource.group.name
        : '' }}
    </v-subheader>
  </div>
  <span
    v-else-if="item.resourceName"
    class="h7-text-medium">>
    <span class="mr-1">#{{ item.id }}. </span>
    {{ item.resourceName }}
  </span>
</template>

<script>
export default {
  name: 'resourceName',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
}
</script>
